document.addEventListener('DOMContentLoaded', () => {
    let cont = document.getElementById('uncomplicated-icons'),
        items = cont.querySelectorAll('.subcat-grid-item'),
        toggleButton = document.querySelector('.category-icons-toggle'),
        screen,
        itemsToShow,
        resizeTimeout;

    getConfigurations();
    manageClasses('load');
    observeChanges();

    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            getConfigurations();
            manageClasses('resize');
        }, 150);
    });

    toggleButton.addEventListener('click', () => {
        manageClasses('click');
    });

    function observeChanges() {
        const observer = new MutationObserver(mutationsList => {
            mutationsList.forEach(mutation => {
                mutation.attributeName === 'class' && mutation.target.classList.contains('open') ?
                    toggleButton.innerText = 'Show Less' :
                    toggleButton.innerText = 'Show More';
            });
        });

        observer.observe(toggleButton, {
            attributes: true,
            attributeFilter: ['class']
        });
    }

    function getConfigurations() {
        const width = window.innerWidth;
        if (width >= 990) {
            screen = 'large';
            itemsToShow = 16;
        } else if (width >= 750) {
            screen = 'medium';
            itemsToShow = 6;
        } else {
            screen = 'small';
            itemsToShow = 4;
        }
    }

    function manageClasses(action) {
        if (action === 'load') {
            onLoad();
        } else if (action === 'click') {
            onClick();
        } else if (action === 'resize') {
            onResize();
        }
    }

    function onLoad() {
        items.forEach((item, index) => {
            if (index >= itemsToShow) {
                item.classList.add('subcat-hidden');
                toggleButton.classList.remove('hidden');
            }
        });
    }

    function onClick() {
        const isOpen = toggleButton.classList.toggle('open');
        items.forEach((item, index) => {
            if (index >= itemsToShow) {
                item.classList.toggle('subcat-hidden', !isOpen);
            }
        });
    }

    function onResize() {
        toggleButton.classList.remove('open');
        items.forEach((item, index) => {
            if (index >= itemsToShow) {
                item.classList.add('subcat-hidden');
                toggleButton.classList.remove('hidden');
            } else {
                item.classList.remove('subcat-hidden');
                toggleButton.classList.add('hidden');
            }
        });
    }
});